import type { FindAdresseProcheQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { adresses } from '~/msw/mocks/adresse/adresses'

/** Adresse la plus proche : la première adresse à numéro du jeu de données, quel que soit le point. */
export function findAdresseProcheHandler() {
  return http.get<never, never, FindAdresseProcheQueryResponse>('http://localhost:3000/api/v1/adresses/proche', () => {
    const nearest = adresses.find(adresse => adresse.precision === 'housenumber')
    return HttpResponse.json(nearest ? [nearest] : [])
  })
}
